import { camelToSnake, snakeToCamel } from "caseparser";
import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { FormData } from "../form-sections/types";

interface RegisterAppUserPayload {
  user: Record<string, any>; // Mejora si tienes la forma exacta
}

interface RegisterAppSetupParams {
  token: string;
  fee: string;
  branch_id: string;
}

export const registerAppUserApi = api
  .enhanceEndpoints({ addTagTypes: ["Users"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      registerAppUser: builder.mutation<any, RegisterAppUserPayload>({
        query: ({ user }) => ({
          url: `register_app/setup`,
          method: RequestMethod.POST,
          body: camelToSnake(user),
        }),
        transformResponse: (response: any) => response,
        invalidatesTags: (_result, _error, _arg) => [
          { type: "Users", id: "LIST" },
        ],
      }),

      registerAppSetup: builder.query<any, RegisterAppSetupParams>({
        query: ({ token, fee, branch_id }) => ({
          url: `register_app/setup?token=${token}&fee=${fee}&branche_id=${branch_id}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response?.data ?? response),
      }),

      registerAppSetupForm: builder.mutation<any, FormData>({
        query: (data: FormData) => ({
          url: `register_app/setup`,
          method: RequestMethod.POST,
          body: data,
        }),
        transformResponse: (response: any) => snakeToCamel(response?.data ?? response),
      }),
    }),
  });

export const {
  useRegisterAppUserMutation,
  useRegisterAppSetupQuery,
  useRegisterAppSetupFormMutation,
} = registerAppUserApi;
